














import { defineComponent } from '@vue/composition-api';

import usageOption from '@/table/setting/usage';

import getLogs from '@/gql/log/getLogs.gql';

const Usage = defineComponent({
  setup() {
    const logsResult = (data: any) => data.logs;

    return {
      usageOption,
      getLogs,
      logsResult,
    };
  },
});

export default Usage;
